/**
 * @created on 2018/1/5
 * @author laixinyu <laixinyualex@gmail.com>
 **/

// 个人相关
const userIndex = resolve => require(['../../../views/user/userIndex'], resolve)

// 问答主页
const qaUserHome = resolve =>
  require(['../../../views/user/qaUserHome'], resolve)

// 问答中心
const qaUserIndex = resolve =>
  require(['../../../views/user/qaUserIndex'], resolve)

// 问答-我的成就
const qaAchievement = resolve =>
  require(['../../../views/user/qaAchievement'], resolve)

export default [
  {
    path: '/userIndex',
    component: userIndex,
    meta: {
      business: '公共',
      pageName: '个人主页'
    }
  },
  {
    path: '/qaUserHome',
    component: qaUserHome
  },
  {
    path: '/qaUserIndex',
    component: qaUserIndex
  },
  {
    path: '/qaAchievement',
    component: qaAchievement
  }
]



// WEBPACK FOOTER //
// ./src/router/page/user/index.js